// Copyright (C) 2020 TANNER AG

import React from "react";
import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import NotificationMenuItem from "./NotificationMenuItem";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import podcastImage from "../assets/images/podcasts.png";

const styles = theme => ({
    root: {
        position: "absolute",
        top: 0,
        right: 0
    },
    buttonStyle: {
        padding: '5px 10px 0 10px'
    },
    badgeStyle: {
        backgroundColor: '#E40045',
        color: '#fff',
        top: '-7px',
        right: '-10px',
        minWidth: 20,
        width: 'auto',
        height: 21,
        padding: '0 4px 1px',
        borderRadius: '11px',
        border: '2px solid #303C49',
        fontSize: '11px'
    },
    menuPaperStyle: {
        backgroundColor: 'transparent',
        '&:before': {
            content: '""',
            height: '10px',
            width: '10px',
            display: 'block',
            position: 'absolute',
            right: '113px',
            top: '2px',
            borderRadius: '2px',
            backgroundColor: '#fff',
            transform: 'rotate(45deg)'
        }
    },
    menuListStyle: {
        backgroundColor: '#fff',
        borderRadius: '4px',
        padding: '0 0 12px',
        marginTop: '6px'
    },
    menuItemStyle: {
        padding: 0,
        position: 'relative',
        height: 'inherit',
        width: '350px',
        maxWidth: '350px',
        backgroundColor: '#fff',
        '&:first-child': {
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px'
        },
        borderBottom: '1px solid #fff'
    },
    itemUnreadStyle: {
        '&:before': {
            position: 'absolute',
            top: 0,
            left: 0,
            right: '5px',
            bottom: 0,
            background: '#E40045',
            width: '6px',
            content: '""',
            display: 'block',
            borderBottom: '1px solid #fff'
        }
    },
    itemCtaStyle: {
        padding: 0,
        margin: '12px 16px 0',
        height: 38,
        maxWidth: '350px',
        backgroundColor: '#e40045',
        borderRadius: 4,
        color: '#fff',
        '&:hover': {
            backgroundColor: '#b10036'
        },
        '& span': {
            fontSize: theme.typography.pxToRem(12),
            fontFamily: 'Arial, sans-serif',
            lineHeight: 'normal',
            fontWeight: 'normal',
            textAlign: 'center',
            width: '100%'
        }
    }
})

const PodcastsReferences = ({ classes, history, generalTranslations, podcasts }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const {
        buttonStyle,
        menuPaperStyle,
        menuListStyle,
        menuItemStyle,
        itemCtaStyle,
        root
    } = classes;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (!podcasts || !podcasts.length) {
        return null;
    }

    return (
        <div className={root}>
            <ButtonBase
                className={buttonStyle}
                aria-owns={anchorEl ? 'settings-menu' : null}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <img src={podcastImage} alt="podcasts"/>
            </ButtonBase>
            <Menu
                classes={{ paper: menuPaperStyle }}
                id="notifications-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 140
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                getContentAnchorEl={null}
                MenuListProps={{ className: menuListStyle }}
            >
                {podcasts.map(({ id, title, shortdescription, publicationDate}) => (
                    <MenuItem
                        key={id}
                        className={menuItemStyle}
                        onClick={() => {
                            history.push(`/buscast/${id}`);
                            handleClose();
                        }}
                    >
                        <NotificationMenuItem
                            date={publicationDate}
                            headline={title}
                            text={shortdescription}
                            isUnread={false}
                        />
                    </MenuItem>
                ))}
                <MenuItem
                    className={itemCtaStyle}
                    onClick={() => {
                        history.push('/podcasts')
                        handleClose()
                    }}
                >
                    <span>{generalTranslations('show-podcasts')}</span>
                </MenuItem>
            </Menu>
        </div>
    );
};

PodcastsReferences.propTypes = {
    podcasts: PropTypes.array
};

export default compose(
    withRouter,
    withGeneralTranslations,
    withStyles(styles)
)(PodcastsReferences)



// WEBPACK FOOTER //
// ./src/components/PodcastsReferences.js